module.exports = __webpack_public_path__ + "img/arrow_back_up_white.1d7f58e6.svg";